module.exports = __webpack_public_path__ + "static/media/Hook.682283bd.JPG";